/**
 * Audio Visualizer Application
 * Main entry point for the Vite-powered app
 */

import { initApp } from './app/init.js';

// Bootstrap the application
initApp();
